module.exports = __webpack_public_path__ + "static/swiftui-3f94d9cb34a5fea13d47240a6e5c42eb.png";